import { Component, OnInit, inject } from "@angular/core";
import { DeviceService, UserRoleEnum } from "../../../core-ui";
import { UserService } from "../../../core-ui/services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LocaleService } from "../../services/locale.service";

@Component({
  selector: "app-thank-you",
  templateUrl: "./thank-you.component.html",
  styleUrls: ["./thank-you.component.scss"],
  standalone: false,
})
export class ThankYouComponent implements OnInit {
  private deviceService = inject(DeviceService);
  private userService = inject(UserService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private localeService = inject(LocaleService);

  isCustomer: boolean;
  isAgent: boolean;

  ngOnInit() {
    this.userService.getActiveUser()?.unauthenticate();
    // no guard runs here, so on a refresh fall back to the cached application translations
    this.localeService.restoreCachedTranslations();
    const role = this.route.snapshot.paramMap.get("role");
    this.isCustomer = role === UserRoleEnum.customer.toLowerCase();
    this.isAgent = role === UserRoleEnum.agent.toLowerCase();
  }
}
